import React, { useState, useEffect } from 'react';
import { Bug, X, Send, Loader2 } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const API = process.env.REACT_APP_BACKEND_URL;

export default function BugReportButton() {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ page_url: window.location.href, description: '', email: '' });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const handler = () => { setOpen(true); setForm(f => ({ ...f, page_url: window.location.href })); };
    window.addEventListener('toggle-bug-report', handler);
    return () => window.removeEventListener('toggle-bug-report', handler);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${API}/api/bug-report`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      setSubmitted(true);
      setTimeout(() => { setOpen(false); setSubmitted(false); setForm({ page_url: window.location.href, description: '', email: '' }); }, 2000);
    } catch {} finally { setLoading(false); }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-end sm:items-center justify-center z-[60] p-4" onClick={e => e.target === e.currentTarget && setOpen(false)}>
      <div className="bg-white dark:bg-gray-800 rounded-2xl w-full max-w-md p-6 shadow-2xl animate-fade-in">
        {submitted ? (
          <div className="text-center py-6">
            <div className="w-14 h-14 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-3">
              <Send size={24} className="text-green-500" />
            </div>
            <h3 className="font-serif font-bold text-navy dark:text-white text-lg">Hvala!</h3>
            <p className="text-gray-500 text-sm mt-1">Vaša prijava je zaprimljena.</p>
          </div>
        ) : (
          <>
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-2">
                <Bug size={20} className="text-red-500" />
                <h3 className="font-serif font-bold text-navy dark:text-white">Prijavi grešku</h3>
              </div>
              <button onClick={() => setOpen(false)}><X size={18} className="text-gray-400 hover:text-gray-600" /></button>
            </div>
            <form onSubmit={handleSubmit} className="space-y-3">
              <input value={form.page_url} onChange={e => setForm({ ...form, page_url: e.target.value })} placeholder="URL stranice"
                className="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg text-sm dark:bg-gray-700 dark:text-white" />
              <input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Vaš e-mail (opcionalno)" type="email"
                className="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg text-sm dark:bg-gray-700 dark:text-white" />
              <textarea required value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                placeholder="Opišite grešku..." rows={3}
                className="w-full px-3 py-2 border border-gray-200 dark:border-gray-600 rounded-lg text-sm dark:bg-gray-700 dark:text-white resize-none" />
              <button type="submit" disabled={loading}
                className="w-full px-4 py-2.5 bg-red-500 text-white rounded-lg text-sm font-medium hover:bg-red-600 disabled:opacity-50 transition-colors flex items-center justify-center gap-2">
                {loading ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
                {loading ? 'Šaljem...' : 'Pošalji prijavu'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
